import { Applicant } from '@common/entities';
import { ApplicantApplicationResponse } from '@common/entities/src/applicant-application-response.entity';

export function getActiveResponse(
  applicant: Applicant,
  responseId: string,
): ApplicantApplicationResponse {
  const responses = applicant.responses ?? [];
  const response = responses.find((item) => item.responseId === responseId);
  if (!response) {
    throw new Error(`Application response ${responseId} is not available.`);
  }
  return response;
}
